import { initialize as initializeLaunchDarkly } from "launchdarkly-js-client-sdk"
import { ANDROID, APPLE } from 'common/constants'
import { updateFeatures } from 'common/redux/auth'

export const deviceType = () => {
  if (/IEMobile/i.test(navigator.userAgent)) {
    // windows needs to come before android because it can contain it
    return ''
  } else if (/Android/i.test(navigator.userAgent)) {
    return ANDROID
  } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    return APPLE
  }
  return ''
}

export const getUrlFlag = (flag, options = {}) => {
  const { isCached = true } = options
  const shouldSetFlag = window.location.href.includes(`${flag}=`)
  const flagAlreadySet = !!window.localStorage.getItem(flag)

  if (shouldSetFlag && !flagAlreadySet && isCached) {
    window.localStorage.setItem(flag, true)
  }

  return shouldSetFlag || flagAlreadySet
}

export const isEmbedded = () => getUrlFlag('embed')

export const isHeaderHidden = () => getUrlFlag('rmHideHeader')

export const isDrawerTitleHidden = () => getUrlFlag('rmHideDrawerTitle')

export const isFirstUse = () => getUrlFlag('isFirstUse', { isCached: false })

export const isEmbeddedOrMobileBrowser = () => {
  return isEmbedded() || deviceType() !== ''
}

export const canAccessEmbeddedFeature = (feature) => {
  if (!isEmbedded()) {
    return false
  }

  if (!window.feature_flags || !(feature in window.feature_flags)) {
    return false
  }
  return window.feature_flags[feature]
}

let ldClient = null

export const initializeFeatures = ({bootstrap, clientSideId, secureModeHash, userProfile}) => {
  ldClient = null

  if (!clientSideId || !secureModeHash || !userProfile) {
    return
  }

  const ldOptions = {
    hash: secureModeHash,
    bootstrap: bootstrap,
    sendEventsOnlyForVariation: true,
  }

  ldClient = initializeLaunchDarkly(clientSideId, userProfile, ldOptions)
  ldClient.on('change', (settings) => { updateFeatures(settings) })
}

export const getFeature = (featureFlag, defaultValue) => {
  if (!ldClient) {
    return defaultValue
  }

  return ldClient.variation(featureFlag, defaultValue)
}

export const getFeatures = () => {
  if (!ldClient) {
    return {}
  }

  return ldClient.allFlags()
}

export const trackGoal = (goalKey, goalData) => {
  if (!ldClient) {
    return
  }

  ldClient.track(goalKey, goalData)
}
